import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
            加入追剧同好的讨论，发现更多值得一看的好剧
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className={`group relative inline-flex items-center gap-2.5 px-5 py-3 rounded-full cursor-pointer transition-all duration-300 hover:scale-105 ${
                item.hot
                  ? 'bg-primary-500 text-white'
                  : 'bg-white text-foreground-700 border border-background-200/70 hover:border-primary-200 hover:text-primary-500'
              }`}
            >
              {item.hot && (
                <i className="ri-fire-line text-accent-300 text-sm"></i>
              )}
              <span className="text-sm md:text-base font-medium whitespace-nowrap">
                {item.name}
              </span>
              <span
                className={`text-xs whitespace-nowrap ${
                  item.hot ? 'text-white/70' : 'text-foreground-400'
                }`}
              >
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}